import React from 'react';

import type { StepRefs } from '../../data-layer/types';
import ChatFlow from '../ChatFlow/ChatFlow';

import './MainContent.css';

interface MainContentProps {
  containerRef: React.RefObject<HTMLDivElement>;
  stepRefs: StepRefs;
  scrollToStep: (stepName: string) => void;
}

/**
 * Main content area using modular components
 */
function MainContent({
  containerRef,
  stepRefs,
  scrollToStep,
}: MainContentProps) {
  return (
    <div className='Copilot-Content'>
      <ChatFlow
        containerRef={containerRef}
        stepRefs={stepRefs}
        scrollToStep={scrollToStep}
      />
    </div>
  );
}

export default MainContent;
